// Angular imports
import { Injectable } from '@angular/core';

// Rxjs imports
import { Observable, Subject } from 'rxjs';

// 3rd party Imports
import { DxFormComponent } from 'devextreme-angular';

// Common imports
import { Utils } from 'cc-common';

// Model imports
import { ILocalContextFactory } from '../../../../dashboard-module/_interfaces/local-context-factory';
import { EntitySelectorResultDto } from '../../_models/common/enity-selector-result-dto';

/**
 * Helper class to maintain selected entity and form context for Corporate cirabooks module
 */

@Injectable({
    providedIn: 'root'
})
export class CCBHelperService implements ILocalContextFactory {
    private readonly _subjectSelectedEntity: Subject<EntitySelectorResultDto> = new Subject();
    private readonly _subjectFilterFormReady: Subject<boolean> = new Subject();

    private readonly _subjectWidgetContext: Subject<any> = new Subject();
    private readonly _updateSecurityInfo: Subject<any> = new Subject();

    private _selectedEntity: EntitySelectorResultDto;
    private _filterForm: DxFormComponent;

    //#region CCB Context methods

    getContext(): Observable<any> {
        return new Observable((observer) => {
            this._subjectSelectedEntity.subscribe((context) => observer.next(context));
        });
    }

    getLocalContext(): any {
        return this._selectedEntity;
    }

    updateContext(context: any): void {
        this._selectedEntity = null;

        if (Utils.notNullAndDefined(context) && Utils.notNullAndDefined(context.entityId)) {
            this._selectedEntity = context.entityId;
        }
    }

    //#endregion

    //#region Widget Context methods

    /**
     * @param context Widget context contains selected entity id, entity name and widget id
     */
    updateWidgetContextSubject(context: any): void {
        this._subjectWidgetContext.next(context);
    }

    getWidgetContextSubject(): Observable<any> {
        return this._subjectWidgetContext;
    }

    //#endregion

    //#region Entity Context methods

    updateSelectedEntitySubject(entity: EntitySelectorResultDto): void {
        this._selectedEntity = entity;
        this._subjectSelectedEntity.next(entity);
    }

    getSelectedEntitySubject(): Observable<EntitySelectorResultDto> {
        return this._subjectSelectedEntity;
    }

    getSelectedEntity(): EntitySelectorResultDto {
        return this._selectedEntity;
    }

    //#endregion

    //#region Form Context methods

    getSubjectFilterFormReady(): Subject<boolean> {
        return this._subjectFilterFormReady;
    }

    updateSubjectFilterFormReady(filterForm: DxFormComponent): void {
        this._filterForm = filterForm;
        this._subjectFilterFormReady.next(true);
    }

    getFilterForm(): DxFormComponent {
        return this._filterForm;
    }

    getSecurityInfo(): Subject<any> {
        return this._updateSecurityInfo;
    }

    updateSecurityInfo(value: any): void {
        this._updateSecurityInfo.next(value);
    }
    //#endregion
}
